import 'sticky-kit/dist/sticky-kit';

export default function() {
  if ($(window).width() >= 768) {
    if ($('.entry-meta-wrapper-sticky').length) {
      $('.entry-meta-wrapper-sticky').each(function () {
        var parent = $(this).parent();
        var section = $(this).closest('.herald-section');
        var height = section.find('.herald-entry-content').parent().height() - 70;
        parent.css('min-height', height);
      });
      $('.entry-meta-wrapper-sticky').stick_in_parent();
    }
  } else {
    $('.entry-meta-wrapper-sticky').each(function () {
      $(this).css('height', 'auto');
      $(this).css('min-height', '1px');
    });
    $(".entry-meta-wrapper-sticky").trigger("sticky_kit:detach");
  }
}
